import React, { Suspense, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { lazyRetry, whenIdle } from '@/lib/lazyRetry';

const SahiVoiceOrb = lazyRetry(() => import('@/components/orb/SahiVoiceOrb'));
const FeedbackWidget = lazyRetry(() => import('@/components/FeedbackWidget'));
const ReportIssueWidget = lazyRetry(() => import('@/components/ReportIssueWidget'));
const PWAInstallPrompt = lazyRetry(() => import('@/components/PWAInstallPrompt'));

const SHARE_PREFIXES = ['/portrait-card/', '/compare/', '/journey-view/'];

/** Floating companions (Sahi orb, feedback, report-a-problem, PWA prompt) mount once the page is idle, off the critical path. */
export function DeferredWidgets() {
  const location = useLocation();
  const [ready, setReady] = useState(false);
  useEffect(() => whenIdle(() => setReady(true), 1500), []);

  if (!ready) return null;
  if (SHARE_PREFIXES.some((p) => location.pathname.startsWith(p))) return null;   // public share pages stay clean
  return (
    <Suspense fallback={null}>
      <SahiVoiceOrb />
      <FeedbackWidget />
      <ReportIssueWidget />
      <PWAInstallPrompt />
    </Suspense>
  );
}
